// import { XPlatform } from '@iv/core';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AppId, DevelopEnvironment, Environment } from "@foxeet/domain";

enum XPlatform {
  WEB_ADMIN = 0,
  MOBILE = 1,
  WEB_CUSTOMER = 2,
}

export const environment: Environment = {
  app: AppId.AVM,
  appName: "AVM",
  envName: DevelopEnvironment.dev,
  wikiURL: "https://wiki-force.valumre.com/",
  platform: XPlatform.WEB_ADMIN,
  production: false,
  version: "1.0.0",
  //   defaultEndpoint: 'https://192.168.16.10:5001', // Javi
  //   defaultEndpoint: 'https://localhost:5001', // Javi
  // defaultEndpoint: 'https://192.168.16.25:5001', // Gilbert
  // defaultEndpoint: 'https://192.168.16.24:5001', // Alfredo
  // defaultEndpoint: 'https://192.168.16.50:5001', // Alberto
  // defaultEndpoint: 'https://192.168.16.37:5001', // David

  defaultEndpoint: "https://apibatch-dev.smartasolution.com",
  // defaultEndpoint: 'https://192.168.16.10:5001',
  devEndpoint: "https://apibatch-dev.smartasolution.com",
  qaEndpoint: " https://batch.iv.solutions",
  prodEndpoint: "http://batch.iv.solutions",

  mapbox: {
    accessToken: "pk.eyJ1IjoiaW5zdGl0dXRvIiwiYSI6ImNrNmF1bHc5aTAxbHUzbXNicmdpYWFuMGcifQ.oLGQ854cghe8ypDxZ1-3HQ"
  },
  googleMapsApiKey: "AIzaSyBPvVFZ8zWT8uOiYlPUb3zcgGD0oods9dc"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
